import { Checkbox } from 'primereact/checkbox';
import { type ReactNode } from 'react';

import { cn } from '@shared/lib/cn';

export interface BaseCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  hint?: ReactNode;
  disabled?: boolean;
  /** The prototype's bordered "check card" look (permission lists, services). */
  card?: boolean;
}

export function BaseCheckbox({ id, checked, onChange, label, hint, disabled, card }: BaseCheckboxProps) {
  return (
    <div
      className={cn(
        'flex items-start gap-2.5',
        card && 'rounded-app border border-line-strong bg-surface-2 px-2.5 py-2',
        card && checked && 'border-accent bg-accent-soft',
        disabled && 'opacity-55',
      )}
    >
      <Checkbox
        inputId={id}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          onChange(Boolean(e.checked));
        }}
      />
      <label htmlFor={id} className={cn('flex flex-col text-[12.5px]', !disabled && 'cursor-pointer')}>
        <span className={cn(card && checked && 'font-semibold text-accent')}>{label}</span>
        {hint && <span className="text-[11px] text-text-3">{hint}</span>}
      </label>
    </div>
  );
}
